import "core-js/modules/es6.reflect.construct.js";
import _extends from "@babel/runtime/helpers/extends";
import _objectDestructuringEmpty from "@babel/runtime/helpers/objectDestructuringEmpty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _excluded = ["showClose", "onChange", "showHour", "showMinute", "showSecond", "tabIndex", "mode", "dropdownStyle", "locale"];

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";

/**
 * Created by chief on 17/4/6.
 */
import React, { Component } from "react";
import RangeCalendar from "./rc-calendar/RangeCalendar";
import TimePickerPanel from "rc-time-picker/lib/Panel";
import Picker from "./rc-calendar/Picker";
import InputGroup from '../../wui-input-group/src';
import Input from "../../wui-input/src"; // import getLang from "./lang-utils";

import { getLangInfo } from "./lang-utils";
import Icon from "../../wui-icon/src";
import classNames from 'classnames';
import { KeyCode } from '../../wui-core/src';
import { formatDate } from './rc-calendar/util'; // import {get} from "lodash-es"
// import zhCN from "./locale/zh_CN";

import omit from 'omit.js';
import { prefix } from "../../wui-core/src/index.js";
import moment from "moment"; // import "moment/locale/zh-tw";
// import "moment/locale/zh-cn";
// import "moment/locale/en-gb";
// function formatDate(value,format) {
//     if (!value) {
//         return '';
//       }
//       if (Array.isArray(format)) {
//         format = format[0];
//       }
//       return value.formatDate(format);
// }
// const fullFormat = "YYYY-MM-DD";

var cn = typeof window !== 'undefined' ? location.search.indexOf("cn") !== -1 : true;
var now = moment();

function isValidRange(v) {
  return v && v[0] && v[1];
}

if (cn) {
  now.locale("zh-cn").utcOffset(8);
} else {
  now.locale("en-gb").utcOffset(0);
}
/**
 * @desc 阻止事件冒泡传播兼容ie
 */


function stopBubble(event) {
  //如果提供了事件对象，则这是一个非IE浏览器
  if (event && event.stopPropagation) {
    //因此它支持W3C的stopPropagation()方法
    event.stopPropagation();
    event.preventDefault(); // 取消事件的默认行为
  } else {
    //否则，我们需要使用IE的方式来取消事件冒泡
    window.event.cancelBubble = true;
    window.event.returnValue = false; //阻止事件的默认行为
  }
}

function isArraysEqual(a, b) {
  if (a === b) return true;

  if (a === null || typeof a === 'undefined' || b === null || typeof b === 'undefined') {
    return false;
  }

  if (a.length !== b.length) return false;

  for (var i = 0; i < a.length; ++i) {
    if (a[i] !== b[i]) return false;
  }

  return true;
}

var RangePicker = /*#__PURE__*/function (_Component) {
  _inherits(RangePicker, _Component);

  var _super = _createSuper(RangePicker);

  function RangePicker(_props, context) {
    var _this;

    _classCallCheck(this, RangePicker);

    _this = _super.call(this, _props, context);

    _defineProperty(_assertThisInitialized(_this), "modifyPanelValues", function (values, langInfo) {
      if (!values) return null;

      if (typeof values === 'string' && moment(values).isValid && moment(values).isValid()) {
        var nextMonthDate = moment(values).clone().add(1, 'months').format(_this.props.format);
        nextMonthDate.locale(langInfo.lang);
        return [values, nextMonthDate];
      } else if (values && values.length && values.length === 2) {
        return values.map(function (value) {
          if (moment(value).isValid && moment(value).isValid()) {
            return value;
          } else {
            return '';
          }
        });
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "initValue", function (props) {
      var valueProp = props.value || props.defaultValue || [];
      var values = [];

      for (var i = 0; i < 2; i++) {
        var value = valueProp[i] || '';

        if (value) {
          if (typeof value == 'string') {
            if (moment(value) && moment(value).isValid()) {
              values.push(moment(value));
            } else {
              console.error('value is not in the correct format');
              values.push('');
            }
          } else if (value.format && value.isValid && value.isValid()) {
            values.push(value);
          } else {
            console.error('value is not in the correct format');
            values = [];
          }
        } else {
          values.push('');
        }
      }

      return values;
    });

    _defineProperty(_assertThisInitialized(_this), "clearHoverValue", function () {
      return _this.setState({
        hoverValue: []
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onChange", function (value) {
      var props = _this.props;
      var formatStr = props.format || 'YYYY-MM-DD';

      if (value.length < 2) {
        return;
      }

      _this.setState({
        value: value
      }); //传入value和dateString


      if (props.onChange && isValidRange(value) || value.length == 0) {
        if (value.length > 0) {
          props.onChange(value, "[\"".concat(formatDate(value[0], formatStr), "\" , \"").concat(formatDate(value[1], formatStr), "\"]"), ["".concat(formatDate(value[0], formatStr)), "".concat(formatDate(value[1], formatStr))]);
        } else {
          props.onChange(null);
        }
      } else {
        props.onPanelChange && props.onPanelChange(value);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handlePanelChange", function (_, mode) {
      // console.log("this.props.mode", this.props.mode);
      // const m = this.props.mode || ['date', 'date']
      // if (m === "year") {
      //     this.setState({ modeArr: ["year", "year"] });
      // } else if (m === "month") {
      //     if (!mode.includes("date")) {
      //         this.setState({ modeArr: mode });
      //       }
      // } else {
      //     this.setState({ modeArr: mode });
      // }
      _this.setState({
        modeArr: mode
      }); // if (!mode.includes("date")) {
      //   this.setState({ modeArr: mode });
      // }

    });

    _defineProperty(_assertThisInitialized(_this), "onHoverChange", function (hoverValue) {
      _this.setState({
        hoverValue: hoverValue
      });

      _this.props.onHoverChange && _this.props.onHoverChange(hoverValue);
    });

    _defineProperty(_assertThisInitialized(_this), "remove", function (e) {
      _this.setState({
        value: ''
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleCalendarChange", function (value) {});

    _defineProperty(_assertThisInitialized(_this), "onMouseLeave", function (e) {
      _this.setState({
        showClose: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "onMouseEnter", function (e) {
      if (!_this.valueIsEmpty(_this.state.value)) {
        _this.setState({
          showClose: true
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "valueIsEmpty", function (value) {
      if (value) {
        if (value.length == 0) {
          return true;
        } else {
          //value.length>0
          var flag = true;
          if (value[0] || value[1]) flag = false;
          return flag;
        }
      } else {
        return true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "clear", function (e) {
      stopBubble(e);

      _this.setState({
        value: []
      });

      _this.props.onChange && _this.props.onChange([], []);
      _this.props.onFormControlClear && _this.props.onFormControlClear();
    });

    _defineProperty(_assertThisInitialized(_this), "onOpenChange", function (open) {
      var props = _this.props;

      var self = _assertThisInitialized(_this); // let {value} = this.state;
      // if(!isValidRange(value)){
      //     debugger
      // }


      if (open === false) {
        _this.clearHoverValue();
      }

      _this.setState({
        open: open
      }, function () {
        if (open) {
          setTimeout(function () {
            self.inputFocus();
          }, 0);
        }
      });

      props.onOpenChange && props.onOpenChange(open);

      if (open) {
        setTimeout(function () {
          self.inputFocus();
        }, 200);
      }
    });

    _defineProperty(_assertThisInitialized(_this), "outInputFocus", function (e) {
      if (_this.props.hasOwnProperty('open')) _this.isOpenStopPropagation(e);
      _this.props.outInputFocus && _this.props.outInputFocus(e);
    });

    _defineProperty(_assertThisInitialized(_this), "inputFocus", function () {
      var inputs = document.querySelectorAll(".".concat(prefix, "-date-calendar-input"));

      if (!inputs) {
        return;
      }

      if (inputs[0].value) {
        inputs[0].select();
      } else {
        inputs[0].focus();
      }

      inputs[0].onkeydown = _this.keydownLeft;
      inputs[1].onkeydown = _this.keydownRight;
    });

    _defineProperty(_assertThisInitialized(_this), "keydownLeft", function (e) {
      var inputs = document.querySelectorAll(".".concat(prefix, "-date-calendar-input"));

      if (e.keyCode == KeyCode.ESC) {
        _this.setState({
          open: false
        });

        _this.props.onOpenChange(false, v, v && _this.getValue(v) || '');
      }

      if (e.keyCode == KeyCode.RIGHT || e.keyCode == KeyCode.LEFT) {
        inputs[1].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "keydownRight", function (e) {
      var inputs = document.querySelectorAll(".".concat(prefix, "-date-calendar-input"));

      if (e.keyCode == KeyCode.ESC) {
        _this.setState({
          open: false
        });

        _this.props.onOpenChange(false, v, v && _this.getValue(v) || '');
      }

      if (e.keyCode == KeyCode.LEFT || e.keyCode == KeyCode.RIGHT) {
        inputs[0].focus();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "onStartInputBlur", function (e) {
      var inputs = document.querySelectorAll(".".concat(prefix, "-date-calendar-input"));
      var startValue, endValue;

      if (inputs) {
        startValue = inputs[0].value ? inputs[0].value : '';
        endValue = inputs[1].value ? inputs[1].value : '';
      }

      _this.props.onStartInputBlur && _this.props.onStartInputBlur(e, startValue, "[\"".concat(startValue, "\" , \"").concat(endValue, "\"]"));
    });

    _defineProperty(_assertThisInitialized(_this), "onEndInputBlur", function (e) {
      var inputs = document.querySelectorAll(".".concat(prefix, "-date-calendar-input"));
      var startValue, endValue;

      if (inputs) {
        startValue = inputs[0].value ? inputs[0].value : '';
        endValue = inputs[1].value ? inputs[1].value : '';
      }

      _this.props.onEndInputBlur && _this.props.onEndInputBlur(e, endValue, "[\"".concat(startValue, "\" , \"").concat(endValue, "\"]"));
    });

    _defineProperty(_assertThisInitialized(_this), "isOpenStopPropagation", function (e) {
      if (_this.state.open) stopBubble(e); //只有日期面板被打开的时候才阻止冒泡，否则会影响外侧的tooltips触发
    });

    _defineProperty(_assertThisInitialized(_this), "onOk", function (value) {
      _this.props.onOk && _this.props.onOk(value);
    });

    var initialValue = _props.value || _props.defaultValue;

    var _langInfo = getLangInfo(_props.locale); //获取语言包信息


    _this.state = {
      langInfo: _langInfo,
      hoverValue: [],
      value: _this.initValue(_props),
      open: _props.open || false,
      modeArr: Array.isArray(_props.mode) ? _props.mode : [_props.mode, _props.mode],
      panelValues: initialValue && initialValue.length ? null : _this.modifyPanelValues(_props.panelValues, _langInfo)
    };
    return _this;
  }

  _createClass(RangePicker, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var value = null;

      if ("value" in nextProps) {
        value = this.initValue(nextProps);
        this.setState({
          value: value
        });
      }

      if ("open" in nextProps) {
        this.setState({
          open: nextProps.open
        });
      }

      if ('mode' in nextProps && !isArraysEqual(this.state.modeArr, nextProps.mode)) {
        this.setState({
          modeArr: nextProps.mode
        });
      }

      if ("renderIcon" in nextProps) {
        this.setState({
          renderIcon: nextProps.renderIcon
        });
      }

      if ("locale" in nextProps) {
        var langInfo = getLangInfo(nextProps.locale); //获取语言包信息

        this.setState({
          langInfo: langInfo
        });
      }

      if ("panelValues" in nextProps) {
        var isValueEmpty = !(value || []).some(function (item) {
          return item;
        });
        this.setState({
          panelValues: !isValueEmpty ? null : this.modifyPanelValues(nextProps.panelValues, this.state.langInfo.lang)
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var props = this.props;

      var showClose = props.showClose,
          onChange = props.onChange,
          showHour = props.showHour,
          showMinute = props.showMinute,
          showSecond = props.showSecond,
          tabIndex = props.tabIndex,
          mode = props.mode,
          dropdownStyle = props.dropdownStyle,
          locale = props.locale,
          others = _objectWithoutProperties(props, _excluded);

      var _this$state = this.state,
          value = _this$state.value,
          open = _this$state.open,
          modeArr = _this$state.modeArr,
          langInfo = _this$state.langInfo;
      var formatStr = props.format || 'YYYY-MM-DD';
      var timePickerElement = /*#__PURE__*/React.createElement(TimePickerPanel, {
        showHour: showHour,
        showMinute: showMinute,
        showSecond: showSecond,
        defaultValue: moment(moment().format("HH:mm:ss"), "HH:mm:ss")
      });
      var calendar = /*#__PURE__*/React.createElement(RangeCalendar, {
        hoverValue: this.state.hoverValue,
        onHoverChange: this.onHoverChange,
        showWeekNumber: false,
        format: formatStr,
        mode: modeArr,
        style: dropdownStyle,
        originMode: this.props.mode // TODO: 通过picker简化配置
        ,
        dateInputPlaceholder: !langInfo.lang.includes('en') ? props.dateInputPlaceholder : ['start', 'end'],
        locale: langInfo.langMap,
        onChange: this.onChange,
        disabledDate: props.disabledDate,
        showClear: props.showClear,
        showOk: props.showOk,
        showToday: props.showToday,
        renderFooter: props.renderFooter,
        timePicker: props.showTime ? timePickerElement : null,
        renderError: props.renderError,
        onStartInputBlur: this.onStartInputBlur,
        onEndInputBlur: this.onEndInputBlur,
        onPanelChange: this.handlePanelChange,
        onClear: this.clear,
        onOk: this.onOk,
        validatorFunc: props.validatorFunc,
        panelValues: this.state.panelValues || null
      });
      var classes = classNames(props.className, "".concat(prefix, "-datepicker-container"));
      return /*#__PURE__*/React.createElement("div", _extends({
        className: classes,
        onClick: this.isOpenStopPropagation,
        onMouseOver: this.isOpenStopPropagation
      }, omit(others, ['closeIcon', 'renderIcon', 'showClear', 'showToday', 'locale', 'placeholder', 'showOk', 'dateInputPlaceholder', 'onPanelChange', 'onStartInputBlur', 'onEndInputBlur', 'renderFooter', 'showTime', 'disabledDate', 'disabledTime', 'className', 'panelValue', 'panelValues', 'allowClear', 'renderExtraFooter', 'autoTriggerChange', 'showTime', 'validatorFunc', 'inputTabKeyOpen', 'destroyOnClose', 'disabledYear', "dataIndex", "filterDropdownIncludeKeys", "filterDropdown", "filterDropdownType"])), /*#__PURE__*/React.createElement(Picker, _extends({}, props, {
        value: value,
        animation: 'animation' in props ? props.animation : "slide-up",
        calendar: calendar,
        disabled: props.disabled,
        dropdownClassName: props.dropdownClassName,
        onOpenChange: this.onOpenChange,
        open: open
      }), function (_ref) {
        _objectDestructuringEmpty(_ref);

        return /*#__PURE__*/React.createElement(InputGroup, {
          className: classNames("calendar-picker ".concat(prefix, "-datepicker-input-group"), props.className),
          onMouseEnter: _this2.onMouseEnter,
          onMouseLeave: _this2.onMouseLeave
        }, /*#__PURE__*/React.createElement(Input, {
          placeholder: !langInfo.lang.includes('en') ? _this2.props.placeholder : 'start ~ end',
          value: isValidRange(value) && (_this2.props.inputShowValue && _this2.props.inputShowValue[0] && _this2.props.inputShowValue[1] ? "".concat(_this2.props.inputShowValue[0], " ~ ").concat(_this2.props.inputShowValue[1]) : "".concat(formatDate(value[0], formatStr), " ~ ").concat(formatDate(value[1], formatStr))) || '',
          disabled: props.disabled,
          onFocus: function onFocus(v, e) {
            _this2.outInputFocus(e);
          },
          tabIndex: tabIndex
        }), showClose && !_this2.valueIsEmpty(value) && _this2.state.showClose && !props.disabled ? /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border",
          onClick: _this2.clear
        }, props.closeIcon()) : /*#__PURE__*/React.createElement(Input.Button, {
          shape: "border"
        }, props.renderIcon()));
      }));
    }
  }]);

  return RangePicker;
}(Component);

RangePicker.defaultProps = {
  closeIcon: function closeIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-close-c"
    });
  },
  renderIcon: function renderIcon() {
    return /*#__PURE__*/React.createElement(Icon, {
      type: "uf-calendar"
    });
  },
  // locale:zhCN,//tinper3.x版本
  locale: 'zh-cn',
  //4.x版本
  showClear: true,
  showToday: true,
  showOk: true,
  showClose: true,
  showSecond: true,
  showHour: true,
  showMinute: true,
  mode: ["date", "date"],
  dateInputPlaceholder: ["开始", "结束"],
  placeholder: "开始 ~ 结束",
  validatorFunc: function validatorFunc() {
    return true;
  }
};
export default RangePicker;


// WEBPACK FOOTER //
// ./~/@tinper/next-ui/lib/wui-datepicker/src/RangePicker.js